import EzModalController from 'layouts/modal/modal-controller';
import events from 'lib/events';
import { triggerCustomEvent } from 'lib/helpers';

export default class SignupModalController extends EzModalController {
  connect() {
    super.connect();

    if (this.element.querySelector('.ez-session-modal__download-limit')) {
      triggerCustomEvent(events.three_download_limit.control_pop);
    }
  }

  controlThreeLimitContinue() {
    triggerCustomEvent(events.three_download_limit.control_step_one_click);
  }

  controlThreeLimitFacebookJoin() {
    triggerCustomEvent(events.three_download_limit.control_facebook_join);
  }

  controlThreeLimitGoogleJoin() {
    triggerCustomEvent(events.three_download_limit.control_google_join);
  }

  threeLimitContinue() {
    triggerCustomEvent(events.three_download_limit.step_one_click);
  }

  threeLimitFacebookJoin() {
    triggerCustomEvent(events.three_download_limit.facebook_join);
  }

  threeLimitGoogleJoin() {
    triggerCustomEvent(events.three_download_limit.google_join);
  }

  threeLimitLogin() {
    triggerCustomEvent(events.three_download_limit.login_click);
  }
}
